// title: Memto
// tagline: Notes on the web
// url: http://memto.github.io

// pages_list:
// About: '/about'
// Newterm: '/newterm'
// Archive: '/archive'
// Feed: '/atom.xml'

// categories_list:
// linux: linux - cat
// program: program - cat
// telecom: telecom - cat
// tooltips: tooltips - cat
// misc: misc - cat

export const ghp_title = "MEMTO";
export const ghp_tagline = "Notes on the web";
export const ghp_url = "http://memto.github.io";

export const ghp_pages = [
    { title: "ABOUT", path: "/about" },
    { title: "NEWTERM", path: "/newterm" },
    { title: "ARCHIVE", path: "/archive" },
    { title: "FEED", path: "/atom" },
];

export const ghp_categories = [
    { title: "Linux", path: "/linux-cat" },
    { title: "Program", path: "/program-cat" },
    { title: "Telecom", path: "/telecom-cat" },
    { title: "Tooltips", path: "/tooltips-cat" },
    { title: "Misc", path: "/misc-cat" },
];